import { render, staticRenderFns } from "./VirtualMap.vue?vue&type=template&id=1c79fd0c"
import script from "./VirtualMap.vue?vue&type=script&lang=js"
export * from "./VirtualMap.vue?vue&type=script&lang=js"
import style0 from "./VirtualMap.vue?vue&type=style&index=0&id=1c79fd0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports